import {
  Radio,
  Checkbox,
  FgInput,
  Button,
  Dropdown,
  Card
} from "src/components/UIComponents";
import PPagination from "src/components/UIComponents/Pagination.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import { select } from "d3";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(FgInput.name, FgInput);
    Vue.component(Dropdown.name, Dropdown);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(Radio.name, Radio);
    Vue.component(Button.name, Button);
    Vue.component(Card.name, Card),
      Vue.component(PPagination.name, PPagination);
    Vue.component(Table.name, Table);
    Vue.component(TableColumn.name, TableColumn);
    Vue.component(Select.name, Select);
    Vue.component(Option.name, Option);
  }
};

export default GlobalComponents;
